<template>
  <div>
    <!--タイトル-->
    <header id="header">
      <Header title-image="static/images/common/logo-question.svg" can-back-flag="0" isQuestionDetail="true"></Header>
    </header>

    <div id="wrapper">
      <div class="content">
        
        <!--問題-->
        <div class="q-box">
          <div class="box-l"><img src="static/images/common/icon/icon-q.svg" alt="Q."></div>
          <div class="box-r qStyle">
            <p v-html="question"></p>
          </div>
        </div>

      </div>
    </div>

    <footer id="footer">
      <div class="footer-box">
        <div class="question-footer align-r">
          <div class="box-r">
            <p>{{ currentIndex }} / {{ totalCount }}問</p>
          </div>
        </div>
        <div class="btn-box">
          <button type="button" class="btn btn-answer" v-on:click='showAnswer'><img src="static/images/common/btn/btn-answer.svg" alt="解答"></button>
        </div>
      </div>
    </footer>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'
import cmd from '@/common/Command'
import router from '@/router'

export default {
  mounted: function () {
/*
    //既に達している場合（ブラウザの戻るで再度回答された場合の対応）
    let ret = this.isFinished
    if (ret != "") {
      router.push(ret)
      return
    }
*/
    $("body").removeClass()
    $("body").addClass("page-low")
    $("body").addClass("cat-question")
    $("body").addClass("page-question-question")    
    cmd.adjustStyle()
  },
  
  methods: {
    ...mapActions('QuestionModule', {
      'showAnswer': 'showAnswer'
    }),
  },
  computed: {
    ...mapGetters('QuestionModule', {
      'question': 'question',
      'currentIndex': 'currentIndex',
      'totalCount': 'totalCount',
      'isFinished': 'isFinished'      
    })
  },
  components: {
    Header
  }
}
</script>

<style scoped>
.qStyle {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/QuestionDetail.vue